exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xform-custom-richtext .ql-container {\n  height: 200px;\n  max-height: 400px;\n  overflow: auto;\n}\n", ""]);

// exports
